import { Flower2 } from "lucide-react";

const ITEMS = [
  "Yoga Therapy",
  "Acupuncture",
  "Cupping / Hijama Therapy",
  "Sujok Therapy",
  "Colour Therapy",
  "Ayurveda & Naturopathy",
  "Cancer Rehabilitation Yoga",
  "Pranayama · Mudra · Meditation",
  "Port Blair, Andaman Islands",
  "7+ Years of Excellence",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-emerald-900/10 bg-[#EDF7EF] py-5"
    aria-hidden="true"
  >
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-heading px-6 text-lg italic tracking-wide text-[#2E8B57]/80 sm:text-xl">{item}</span>
              <Flower2 className="h-4 w-4 shrink-0 text-[#1E3A8A]/40" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
